import api from "../../utils/ApiConfig";

export const fetchLivreurTimeline = async (date) => {
  const response = await api.get("/bo/livreurs/timeline", { params: { date } });
  return response.data;
};

export const assignLivreur = async (commandeId, livreurId) => {
  const response = await api.patch(`/bo/commandes-fournisseur/${commandeId}/assign-livreur`, {
    livreur_id: livreurId,
  });
  return response.data;
};
